import { CallParticipantsState } from './CallParticipantsState';
import { CallsState } from './CallsState';
import { State, StateCollection } from './State';
export class DriverState {
    constructor(logFactory, storage) {
        this.busy = new State(false);
        this.calendar = new State({ events: [] });
        this.callInList = new StateCollection();
        this.callSupportsInvitation = new State({});
        this.cameras = new State({});
        this.cameraKeys = new State({}); // Drivers should not need to use this. It is used internally by the framework.
        this.cameraPreset = new State(undefined);
        this.cameraSelected = new State(undefined);
        this.cameraSelfView = new State(false);
        this.cameraSelfViewAuto = new State(false);
        this.cameraSelfViewAvailable = new State(true);
        this.cameraSelfViewPosition = new State('fullscreen');
        this.cameraSelfViewPositions = new State(['fullscreen']);
        this.cameraTracking = new StateCollection();
        this.channel = new State({});
        this.channelKeyboardType = new State('numeric');
        this.channelTuner = new State('cable');
        this.channelTuners = new State([]);
        this.closedCaptioning = new State(false);
        this.contactClosures = new StateCollection();
        this.contentSource = new State('unknown');
        this.contentState = new StateCollection();
        // Currently, DSPs use the old ConfigDetectedValue, everyone else uses Detected.
        this.detected = new State({});
        this.directory = new StateCollection();
        this.disabledCalls = new State({});
        this.displayBlank = new State(false);
        this.displayFreeze = new State(false);
        this.equipmentInfo = new State({});
        this.firmwareVersion = new State('unknown');
        this.lightingLevel = new StateCollection();
        this.lightingLevelRange = new StateCollection();
        this.lightingPower = new StateCollection();
        this.lightingPreset = new StateCollection();
        this.maxCalls = new State({});
        this.mediaOperations = new State({});
        this.mediaPlayerState = new StateCollection();
        this.mediaRecorderStartTime = new StateCollection();
        this.mediaRecorderState = new StateCollection();
        this.mediaStreamerState = new StateCollection();
        this.mute = new State(false);
        this.mutes = new StateCollection();
        this.name = new State('');
        this.navigationKeyboardType = new State('numeric');
        this.power = new State(false);
        this.serialNumber = new State('unknown');
        this.shadeOperations = new State({});
        this.shadePosition = new StateCollection();
        this.shadePositionRange = new StateCollection();
        this.shadePreset = new StateCollection();
        this.shadeTilt = new StateCollection();
        this.shadeTiltRange = new StateCollection();
        this.usbHost = new State('unknown');
        this.validated = new State({});
        this.videoInput = new State('unknown');
        this.videoInputs = new State({});
        this.videoMatrixRoutes = new StateCollection();
        this.volume = new State(0);
        this.volumeRange = new State({ max: 50, min: 0, round: 1 });
        this.volumeMute = new State(false);
        this.volumes = new StateCollection();
        this.volumesRanges = new StateCollection();
        this.log = logFactory.channel('DriverState');
        this.callParticipants = new CallParticipantsState(logFactory);
        this.calls = new CallsState(this.callParticipants, logFactory);
        this.storage = new State(storage);
    }
    getNumSubscriptions(report = false) {
        let numSubscriptions = 0;
        for (const key in this) {
            if (!this.hasOwnProperty(key))
                continue;
            const obj = this[key];
            if (obj instanceof State || obj instanceof StateCollection) {
                const objNumSubscriptions = obj.numSubscriptions;
                if (report && objNumSubscriptions > 0) {
                    this.log.debug(`${key} has ${objNumSubscriptions} subscriptions`);
                }
                numSubscriptions += objNumSubscriptions;
            }
        }
        return numSubscriptions;
    }
    reset(exclusions = []) {
        for (const key in this) {
            if (!this.hasOwnProperty(key))
                continue;
            if (exclusions.includes(key))
                continue;
            const obj = this[key];
            if (obj instanceof State) {
                obj.reset();
            }
            else if (obj instanceof StateCollection) {
                obj.clear();
            }
        }
    }
    unsubscribeAll() {
        for (const key in this) {
            if (!this.hasOwnProperty(key))
                continue;
            const obj = this[key];
            if (obj instanceof State || obj instanceof StateCollection) {
                obj.unsubscribeAll();
            }
        }
    }
}
